import angular from "angular";
import panel from "../services";

function flagUser (panel) {

    return {
        restrict: 'E',
        scope: {
            user: '='
        },
        link: (scope, element) => {
            scope.panel = panel;
            $(element).click(() => {
              panel.action(scope.user, 'flag-user').do(panel.activity().FLAG)
            });
            panel.get('/v1/getReportFlags', (response) => {
                if (panel.okay(response)) {
                   scope.flags = response.flags;
                }
            });
            scope.__flag__ = {user_id:scope.user.register_id, flag_id:'1'};

            scope.reportUser = () => {
                panel.post('/v1/report',scope.__flag__, (response) => {
                    if(panel.okay(response)){
                        scope.cancel();
                        panel.dashboard_message(response.message);
                    }
                });
            }

            scope.getFlagDescription = () => {
                let id = scope.__flag__.flag_id;
                for(let i in scope.flags) {
                    if(scope.flags[i].id === id) {
                        return scope.flags[i].description;
                    }
                }
            }

            scope.cancel = () => {
                $('#flag-user').addClass('hide');
            }
        },
        template: require('./templates/flag-user.html')
    }
};

export default angular.module('directives.flagUser', [panel]).directive('flagUser', flagUser).name;



// WEBPACK FOOTER //
// ./src/app/directives/flagUser.js